"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ExternalSearchResultItem: true,
  SearchResults: true
};
Object.defineProperty(exports, "ExternalSearchResultItem", {
  enumerable: true,
  get: function get() {
    return _ExternalSearchResultItem.default;
  }
});
Object.defineProperty(exports, "SearchResults", {
  enumerable: true,
  get: function get() {
    return _SearchResultsWithMetadata.default;
  }
});

var _eventItem = require("./event-item");

Object.keys(_eventItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _eventItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _eventItem[key];
    }
  });
});

var _ExternalSearchResultItem = _interopRequireDefault(require("./ExternalSearchResultItem"));

var _SearchResultsWithMetadata = _interopRequireDefault(require("./SearchResultsWithMetadata"));

var _searchResult = require("./search-result");

Object.keys(_searchResult).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _searchResult[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _searchResult[key];
    }
  });
});